import { axios } from "../core/axios.interceptor";

export async function getTokenFromAuthCode(state, connectionRequest) {    
  const response = await axios.post(`?state=${state}`, connectionRequest);
  return response;
}

export async function getPluginChange(state) {    
  const response = await axios.get(`plugin-callback?state=${state}`);
  return response;
}
export async function setPluginChange(state) {    
  const response = await axios.post(`plugin-callback`,state);
  return response;
}